<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="col-md-4 col-lg-3">
      <nav class="left-nav">
        <h4 class="mb-2">Statement Categories</h4>
        <div class="items">
          <button
            v-for="category in categories"
            :key="category.id"
            class="btn w-100 text-start"
            :class="[
              selectedCategory?.id === category.id
                ? 'btn-primary'
                : 'btn-simple',
            ]"
            @click="selectCategory(category)"
          >
            {{ category.name }}
          </button>
          <button
            class="btn w-100 text-start"
            :class="[!selectedCategory?.id ? 'btn-primary' : 'btn-simple']"
            @click="newCategory"
          >
            + New Category
          </button>
        </div>
      </nav>
    </div>
    <div class="col-md-8 col-lg-9" v-if="selectedCategory">
      <div class="card p-4">
        <h4 class="mb-4">
          {{ selectedCategory.id ? "Edit Category" : "New Category" }}
        </h4>

        <div class="mb-3">
          <label class="form-label">Category Name</label>
          <input
            type="text"
            class="form-control"
            v-model="selectedCategory.name"
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Pair Webshops (Sale channels)</label>
          <v-select
            multiple
            v-model="selectedCategory.webshop_ids"
            :options="webshops"
            :reduce="(w) => w.id"
            label="name"
            placeholder="Select webshops"
          />
        </div>

        <div class="mb-3">
          <label class="form-label">Pair Integration Pages</label>
          <v-select
            multiple
            v-model="selectedCategory.integration_page_ids"
            :options="integrationPages"
            :reduce="(p) => p.id"
            label="name"
            placeholder="Select integration pages"
          />
        </div>

        <div class="mt-4">
          <button class="btn btn-primary me-2" @click="saveCategory">
            Save
          </button>
          <button
            v-if="selectedCategory.id"
            class="btn btn-danger"
            @click="deleteCategory"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/modules/http";

export default {
  name: "IncomeStatementSettings",
  data() {
    return {
      categories: [],
      webshops: [],
      integrationPages: [],
      selectedCategory: null,
    };
  },
  mounted() {
    this.loadInitialData();
  },
  methods: {
    loadInitialData() {
      http.fetch("/income-statement/categories").then((data) => {
        this.categories = data.data;
      });
      http.fetch("/webshops").then((data) => {
        this.webshops = data;
      });
      http.fetch("/service-integrations/pages").then((data) => {
        this.integrationPages = data.data;
      });
    },
    selectCategory(category) {
      this.selectedCategory = {
        ...category,
        webshop_ids: category.webshops.map((w) => w.id),
        integration_page_ids: category.integrationPages.map((p) => p.id),
      };
    },
    newCategory() {
      this.selectedCategory = {
        name: "",
        webshop_ids: [],
        integration_page_ids: [],
      };
    },
    saveCategory() {
      const url = this.selectedCategory.id
        ? `/income-statement/categories/${this.selectedCategory.id}`
        : "/income-statement/categories";
      const method = this.selectedCategory.id ? "PUT" : "POST";

      http.fetch(url, this.selectedCategory, method).then(() => {
        this.loadInitialData();
        this.selectedCategory = null;
      });
    },
    deleteCategory() {
      if (confirm("Are you sure you want to delete this category?")) {
        http
          .fetch(
            `/income-statement/categories/${this.selectedCategory.id}`,
            null,
            "DELETE"
          )
          .then(() => {
            this.loadInitialData();
            this.selectedCategory = null;
          });
      }
    },
  },
};
</script>

<style scoped>
.left-nav .items .btn {
  margin-bottom: 5px;
}
</style>
